<template>
    <div class="d-flex justify-start mt-2">
        <div
            class="mr-8"
            v-for="link in this.centralLinks"
            :key="link.text"
        >
            <router-link
                :to="link.path"
                class="header-links-link-text"
                >{{ link.text }}</router-link
            >
        </div>
        <div v-if="this.lastLink.path != ''">
            <router-link
                :to="lastLink.path"
                class="header-links-link-text"
                >{{ this.lastLink.text }}</router-link
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderLinks',
    data() {
        return {
            links: [
                { path: '/about/raai_goals', text: 'О РАИИ' },
                { path: '/all_news_page', text: 'Новости' },
                { path: '/all_conferences', text: 'Конференции' },
                { path: '/all_personalities', text: 'Персоналии' },
                { path: '/resources', text: 'Медиаресурсы' }
            ]
        }
    },
    computed: {
        centralLinks() {
            let _centrallinks = []
            for (let i = 0; i < this.links.length - 1; i++)
                _centrallinks.push(this.links[i])
            return _centrallinks
        },
        lastLink() {
            if (this.links.length > 0) return this.links[this.links.length - 1]
            return { path: '', text: '' }
        }
    }
}
</script>
